import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aaea188a")

_pushScopeId("data-v-aaea188a")
const _hoisted_1 = { class: "my-doctor" }
const _hoisted_2 = { class: "title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Doctors = _resolveComponent("Doctors")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Doctors, {
      notSelectable: true,
      required: true,
      isEditable: true,
      possibleTypes: _ctx.PossibleTypes.ALL,
      isHeight: false,
      isFavorite: true
    }, {
      title: _withId(() => [
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.t('favorite doctors')), 1)
      ]),
      _: 1
    }, 8, ["possibleTypes"])
  ]))
})